/**
 * Represents whether a component has completed intialization, i.e. that it is ready to render and that all child components are also intialized
 */
export enum ComponentInitializationState {
    PENDING,
    INITIALIZED
}